module.exports = __webpack_public_path__ + "img/experiences_J Kids corral.9f7beacb.jpg";